<template>
  <svg viewBox="0 0 88 57" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M28.125 0C12.5938 0 0 12.5938 0 28.125C0 43.6562 12.5938 56.25 28.125 56.25C43.6562 56.25 56.25 43.6562 56.25 28.125C56.25 26.1953 56.0391 24.3125 55.6719 22.5L55.5156 21.875H28.125V31.25H46.875C45.3828 40.1172 37.4141 46.875 28.125 46.875C17.7656 46.875 9.375 38.4844 9.375 28.125C9.375 17.7656 17.7656 9.375 28.125 9.375C32.8125 9.375 37.0859 11.1094 40.375 13.9531L47.0938 7.375C42.0938 2.79688 35.4375 0 28.125 0ZM71.875 12.5V21.875H62.5V28.125H71.875V37.5H78.125V28.125H87.5V21.875H78.125V12.5H71.875Z"/>
  </svg>
</template>

